import { createRouter, createWebHashHistory } from 'vue-router'
import { useUserStore } from '@/store/user/index'
import { noLoginRouterList } from './whiteList'
import { DISABLED_NO_WALLET } from '@/config'
import { signUp } from '@/api/user'
import { dispatchCustomEvent } from '@/utils'
import { getAcount } from '@/plugin/chain'
import { showToast } from 'vant'
const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/home/index.vue')
    },
    {
      path: '/lr',
      name: 'lr',
      component: () => import('../views/lr/index.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/login/index.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('../views/register/index.vue')
    },
    {
      path: '/forget',
      name: 'forget',
      component: () => import('../views/forget/index.vue')
    },
    {
      path: '/store',
      name: 'store',
      component: () => import('../views/store/index.vue')
    },
    {
      path: '/flash',
      name: 'flash',
      component: () => import('../views/flash/index.vue')
    },
    {
      path: '/finance',
      name: 'finance',
      component: () => import('../views/finance/index.vue')
    },
    {
      path: '/wallet',
      name: 'wallet',
      component: () => import('../views/wallet/index.vue')
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('../views/help/index.vue')
    },
    {
      path: '/helpDetail/:id',
      name: 'helpDetail',
      component: () => import('../views/help/helpDetail.vue')
    },
    {
      path: '/termService',
      name: 'termService',
      component: () => import('../views/termService/index.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/about/index.vue')
    },
    {
      path: '/langList',
      name: 'langList',
      component: () => import('../views/langList/index.vue')
    },
    {
      path: '/download',
      name: 'download',
      component: () => import('../views/download/index.vue')
    },
    {
      path: '/changePassword',
      name: 'changePassword',
      component: () => import('../views/changePassword/index.vue')
    },
    {
      path: '/fund-password',
      name: 'fund-password',
      component: () => import('../views/fund-password/index.vue')
    },
    {
      path: '/withdrawDeposit',
      name: 'withdrawDeposit',
      component: () => import('../views/withdrawDeposit/index.vue')
    },
    {
      path: '/phoneAuth',
      name: 'phoneAuth',
      component: () => import('../views/phoneAuth/index.vue')
    },
    {
      path: '/emailAuthentication',
      name: 'emailAuthentication',
      component: () => import('../views/emailAuthentication/index.vue')
    },
    {
      path: '/flashExchange',
      name: 'flashExchange',
      component: () => import('../views/flashExchange/index.vue')
    },
    {
      path: '/exchange',
      name: 'exchange',
      component: () => import('../views/exchange/index.vue')
    },
    {
      path: '/invaite',
      name: 'invaite',
      component: () => import('../views/invaite/index.vue')
    },
    {
      path: '/invaite/myTeam',
      name: 'myTeam',
      component: () => import('../views/invaite/ARKADEX/myTeam.vue')
    },
    {
      path: '/invaite/vipGrade',
      name: 'vipGrade',
      component: () => import('../views/invaite/ARKADEX/vipGrade.vue')
    },
    {
      path: '/invaite/ARKADEX/myTeam',
      name: 'invaiteARKADEXMyTeam',
      component: () => import('../views/invaite/ARKADEX/myTeam.vue')
    },

    {
      path: '/proxy',
      name: 'proxy',
      component: () => import('../views/proxy/index.vue')
    },
    {
      path: '/proxy/records',
      name: 'proxyRecords',
      component: () => import('../views/records/index.vue')
    },
    {
      path: '/proxy/earnings',
      name: 'proxyEarnings',
      component: () => import('../views/earnings/index.vue')
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('../views/search/index.vue')
    },
    {
      path: '/message',
      name: 'message',
      component: () => import('../views/message/index.vue')
    },
    {
      path: '/message/detail',
      name: 'messageDetail',
      component: () => import('../views/messageDetail/index.vue')
    },
    {
      path: '/cashflow',
      name: 'cashflow',
      component: () => import('../views/cashflow/index.vue')
    },
    {
      path: '/finance',
      name: 'finance',
      component: () => import('../views/finance/index.vue')
    },
    {
      path: '/finance/subscribe/:id',
      name: 'subscribe',
      component: () => import('../views/subscribe/index.vue')
    },
    {
      path: '/userauth',
      name: 'userauth',
      component: () => import('../views/userauth/index.vue')
    },
    {
      path: '/setpwd',
      name: 'setpwd',
      component: () => import('../views/setpwd/index.vue')
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: () => import('../views/recharge/index.vue')
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      component: () => import('../views/withdraw/index.vue')
    },
    {
      path: '/contract',
      name: 'contract',
      component: () => import('../views/contract/index.vue')
    },
    {
      path: '/trade',
      name: 'trade',
      component: () => import('../views/trade/index.vue')
    },
    {
      path: '/addOptional',
      name: 'addOptional',
      component: () => import('../views/addOptional/index.vue')
    },
    {
      path: '/tradeChart',
      name: 'tradeChart',
      component: () => import('../views/tradeChart/index.vue')
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: () => import('../views/userAgreement/index.vue')
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: () => import('../views/privacyPolicy/index.vue')
    },
    {
      path: '/secrety',
      name: 'secrety',
      component: () => import('../views/secrety/index.vue')
    },
    {
      path: '/switchTheme',
      name: 'switchTheme',
      component: () => import('../views/switchTheme/index.vue')
    },
    {
      path: '/loan',
      name: 'loan',
      component: () => import('../views/loan/index.vue')
    },
    {
      path: '/loan-apply',
      name: 'loanApply',
      component: () => import('../views/loanApply/index.vue')
    },
    {
      path: '/loan-rule',
      name: 'loanRule',
      component: () => import('../views/loanRule/index.vue')
    },
    {
      path: '/no-wallet',
      name: 'noWallet',
      component: () => import('../views/noWallet/index.vue')
    },
    {
      path: '/certification-primary',
      name: 'certificationPrimary',
      component: () => import('../views/certificationPrimary/index.vue')
    },
    {
      path: '/miningRule',
      name: 'miningRule',
      component: () => import('../views/miningRule/index.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
})
router.beforeEach(async (to, from, next) => {
  // 开启 Progress
  const userStore = useUserStore()
  if (to.path == '/no-wallet') {
    next()
  } else if (userStore.isSign) {
    // 已登录
    userStore.getUserInfo()
    if (to.path.indexOf('/i&') > -1) {
      next({ path: '/', replace: true })
    } else {
      next()
    }
  } else {
    // 未登录
    const acountRes = await getAcount()
    if (acountRes == 'no-wallet') {
      // 非钱包
      if (to.path.indexOf('/i&') > -1) {
        let activeCode = to.path.replace('/i&', '')
        next({ path: '/sign-up', query: { invite_code: activeCode }, replace: true })
      } else if (DISABLED_NO_WALLET.includes(__config._APP_ENV)) {
        next('/no-wallet')
      } else {
        if (!noLoginRouterList.includes(to.path)) {
          next('/login')
        } else {
          next()
        }
      }
    } else {
      // 钱包 必登录
      let params = {}
      if (to.path.indexOf('/i&') > -1) {
        let activeCode = to.path.replace('/i&', '')
        params = {
          activeCode: activeCode,
          signType: 0,
          address: acountRes.data.address,
          walletType: acountRes.data.type
        }
      } else {
        params = {
          signType: 0,
          address: acountRes.data.address,
          walletType: acountRes.data.type,
          activeCode: ''
        }
      }
      try {
        const singUpRes = await signUp(params)
        if (singUpRes.code == 200 && singUpRes.data.satoken) {
          // 登录成功
          dispatchCustomEvent('event_toastChange', { name: 'login_success' })
          let token = singUpRes.data.satoken
          userStore.setIsSign(true)
          userStore.setToken(token)
          userStore.getUserInfo()
          next('/')
        } else {
          showToast(singUpRes.msg)
        }
        next()
      } catch (error) {
        next()
      }
    }
  }
})

export default router
